import React from 'react'
import {
  DatePicker,
  Button,
  Table,
  Message,
  Modal,
  Row,
  Col,
  Select,
} from 'antd'
import {
  getSaleJournal,
  getSaleJournalDetail,
  getCategories,
} from '../../../api/businessCommodity'
import { leadoutSaleTable } from '../../../util/index'
import MultiTable from './multiTable'
import moment from 'moment'
import record from '../../ClubTableStatus/component/record'

export default class extends React.Component {
  state = {
    mainList: [],
    commodityMainList: [],
    startTimestamp: '',
    endTimestamp: '',
    chosenDate: '',
    visible: false,
    batchList: [],
    detailData: {
      listing: {
        id: '',
        name: '', //商品名
        photoUrl: '', //图片地址
      },
      sale: {
        saleId: '',
        storeId: '',
        listingId: '', //商品ID
        priceId: '',
        scheduleId: '',
        unitCost: '',
        amount: '', //金额
        quantity: '', //数量
        serialNumber: '', //流水号
        batchNumber: '', //批次号
      },
      member: {
        id: '', //ID
        account: '', //账户
        nickName: '', //昵称
        memberName: '', //用户名称
      },
      table: {
        id: '', //ID
        name: '', //名称
      },
    },
    leadoutDatafff: [],
    dataType: '1',
    monthAmount: 0,
    monthQuantity: 0,
    monthProfit: 0,

    isDisabledBtn: false,
    categoryList: [],
    categoryId: '',
    categoryName: '总',
  }

  constructor(props) {
    super(props)
    this.multiTableRef = React.createRef()
  }

  componentDidMount() {
    this.setState(
      {
        chosenDate: moment().format('YYYY-MM'),
        startTimestamp: moment().startOf('month').format('X'),
        endTimestamp: moment().endOf('month').format('X'),
      },
      () => {
        this.getSaleList()
      }
    )
    this.getCategoryList()
  }

  getCategoryList = async () => {
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getCategories(clubId)
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      categoryList: data,
    })
  }

  getSaleList = async () => {
    this.setState({
      isDisabledBtn: true,
      monthAmount: 0,
      monthProfit: 0,
      monthQuantity: 0,
    })
    const { startTimestamp, endTimestamp, categoryList, categoryId } =
      this.state
    if (startTimestamp && endTimestamp) {
      if (categoryId) {
        categoryList.length > 0 &&
          categoryList.map((item, index) => {
            if (categoryId == item.id) {
              this.setState({
                categoryName: '“' + item.name + '”',
              })
            }
          })
      } else {
        this.setState({
          categoryName: '总',
        })
      }

      const club_id = sessionStorage.getItem('club_id')
      const params = {
        clubId: club_id,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
      }
      const { data, status, detail } = await getSaleJournal(params)
      if (status == 1) {
        // this.setState({ mainList: data.reverse() })
        data &&
          data.map((item, index) => {
            item.amount = item.amount / 100
            item.profit = item.profit / 100
            item.costTotal = item.costTotal / 100
            // this.state.monthAmount += item.amount
            // this.state.monthProfit += item.profit
          })
        if (!this.state.categoryId) {
          this.setState({ leadoutDatafff: data })
        } else {
          const filteredData = data.filter(
            (item) => item.categoryId == this.state.categoryId
          )
          this.setState({ leadoutDatafff: filteredData })
        }
        // this.setState({ leadoutDatafff: data })

        let allDateObj = {}
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          if (
            this.state.categoryId != '' &&
            item.categoryId != this.state.categoryId
          ) {
            continue
          }
          if (!allDateObj[item.date]) {
            allDateObj[item.date] = [item]
          } else {
            allDateObj[item.date].push(item)
          }
        }
        const viewData = []
        for (const key in allDateObj) {
          let totalCount = 0
          let totalAmount = 0
          let totalProfit = 0
          for (let i = 0; i < allDateObj[key].length; i++) {
            const item = allDateObj[key][i]
            totalCount += item.state == 3 ? 0 : item.quantity
            totalAmount += item.amount
            totalProfit += item.profit
          }
          viewData.push({
            date: key,
            totalQuantity: totalCount,
            totalAmount: totalAmount.toFixed(2),
            totalProfit: totalProfit.toFixed(2),
            stockJournals: allDateObj[key],
          })
        }
        viewData &&
          viewData.map((item, index) => {
            item.stockJournals &&
              item.stockJournals.map(($item, $index) => {
                if ($item.type == 5) {
                  this.up($index, item.stockJournals)
                }
              })
          })

        let allCommodityObj = {}
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          if (
            this.state.categoryId != '' &&
            item.categoryId != this.state.categoryId
          ) {
            continue
          }
          let monthAmount = this.state.monthAmount
          let monthProfit = this.state.monthProfit
          let monthQuantity = this.state.monthQuantity
          monthAmount += item.amount
          monthProfit += item.profit
          monthQuantity += item.state == 3 ? 0 : item.quantity
          this.setState({
            monthAmount,
            monthProfit,
            monthQuantity
          })
          if (!allCommodityObj[item.listingId]) {
            allCommodityObj[item.listingId] = [item]
          } else {
            allCommodityObj[item.listingId].push(item)
          }
        }
        const viewCommodityData = []
        for (const key in allCommodityObj) {
          let totalCount = 0
          let totalAmount = 0
          let totalProfit = 0
          for (let i = 0; i < allCommodityObj[key].length; i++) {
            const item = allCommodityObj[key][i]
            totalCount += item.state == 3 ? 0 : item.quantity
            totalAmount += item.amount
            totalProfit += item.profit
          }
          viewCommodityData.push({
            id: key,
            name: allCommodityObj[key][0].name,
            totalQuantity: totalCount,
            totalAmount: totalAmount.toFixed(2),
            totalProfit: totalProfit.toFixed(2),
            stockJournals: allCommodityObj[key],
          })
        }

        this.setState({
          mainList: viewData.reverse(),
          commodityMainList: viewCommodityData.reverse(),
          isDisabledBtn: false,
        })
      } else {
        Message.error(detail)
        this.setState({ isDisabledBtn: false })
      }
    } else {
      Message.error('请选择月份')
    }
  }

  onChange = (date, dateString) => {
    this.setState({
      chosenDate: dateString,
      startTimestamp: date.startOf('month').format('X'),
      endTimestamp: date.endOf('month').format('X'),
    })
  }

  onOk = () => {
    this.setState({ visible: false })
  }

  onCancel = () => {
    this.setState({ visible: false })
  }

  openMultiTable = async (record) => {
    // if (expanded) {
    const { data, status, detail } = await getSaleJournalDetail(record.saleId)
    if (status == 1) {
      // let m_list = []
      // m_list.push(data)
      // m_list = [].concat(data)
      // this.setState({
      //   batchList: m_list,
      // })
      this.setState({
        detailData: data,
        visible: true,
      })
    } else {
      Message.error(detail)
    }
    // }
  }

  render() {
    const mainColumns = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: '总数',
        dataIndex: 'totalQuantity',
        key: 'totalQuantity',
      },
      {
        title: '销售额小计（元）',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
      },
      {
        title: '利润小计（元）',
        dataIndex: 'totalProfit',
        key: 'totalProfit',
      },
    ]

    const CommodityMainColumns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '总数',
        dataIndex: 'totalQuantity',
        key: 'totalQuantity',
        sorter: (a, b) => a.totalQuantity - b.totalQuantity,
      },
      {
        title: '销售额小计（元）',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
      },
      {
        title: '利润小计（元）',
        dataIndex: 'totalProfit',
        key: 'totalProfit',
      },
    ]

    const expandedRowRender = (record, index, indent, expanded) => {
      const batchColumns = [
        {
          title: 'id',
          dataIndex: 'listingId',
          key: 'listingId',
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
          render: (text, record, index) => {
            if (record.state == 3) {
              return (
                <span>
                  {text} <span style={{ color: 'red' }}> (撤销订单)</span>
                </span>
              )
            } else if (record.state == 8) {
              return (
                <span>
                  {text} <span style={{ color: '#FF0062' }}> （套餐赠送）</span>
                </span>
              )
            } else {
              return text
            }
          },
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'salequantity',
        },
        {
          title: '成本（元）',
          dataIndex: 'costTotal',
          key: 'costTotal',
        },
        {
          title: '销售价格（元）',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: '利润（元）',
          dataIndex: 'profit',
          key: 'profit',
        },
        {
          title: '操作',
          dataIndex: 'handling',
          key: 'handling',
          render: (text, record, index) => {
            return (
              <a
                onClick={() => {
                  // this.setState({ visible: true })
                  // this.setState({ detailData: record })
                  // console.log(record)
                  this.openMultiTable(record)
                }}
              >
                详情
              </a>
            )
          },
        },
      ]

      const batchCommodityColumns = [
        {
          title: '日期',
          dataIndex: 'date',
          key: 'date',
          render: (text, record, index) => {
            if (record.state == 3) {
              return (
                <span>
                  {text} <span style={{ color: 'red' }}> (撤销订单)</span>
                </span>
              )
            } else {
              return text
            }
          },
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
          sorter: (a, b) => a.quantity - b.quantity,
        },
        {
          title: '销售价格（元）',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: '利润（元）',
          dataIndex: 'profit',
          key: 'profit',
        },
      ]

      return (
        <MultiTable
          batchColumns={
            this.state.dataType == 1 ? batchColumns : batchCommodityColumns
          }
          record={record}
          // batchList={this.state.batchList}
          batchList={record.stockJournals}
          openMultiTable={this.openMultiTable}
          tableStatus="records"
          ref={this.multiTableRef}
        ></MultiTable>
      )
    }

    return (
      <div>
        <div>
          <DatePicker
            onChange={this.onChange}
            picker="month"
            className="mr-20"
            defaultValue={moment()}
          />

          <Select
            style={{
              width: 120,
            }}
            defaultValue="1"
            options={[
              {
                value: '1',
                label: '按时间统计',
              },
              {
                value: '2',
                label: '按商品统计',
              },
            ]}
            onChange={(value) => {
              this.setState({ dataType: value })
            }}
          ></Select>

          <Select
            placeholder="选择类型"
            className="mr-20 title_slct"
            style={{
              width: 120,
            }}
            onChange={(value) => {
              this.setState({ categoryId: value })
            }}
            value={this.state.categoryId}
          >
            <Select.Option value="">全部类型</Select.Option>
            {this.state.categoryList &&
              this.state.categoryList.map((item, idx) => {
                return (
                  <Select.Option value={item.id} key={item.id}>
                    {item.name}
                  </Select.Option>
                )
              })}
          </Select>

          {this.state.isDisabledBtn ? (
            <Button type="default" className="mr-20" disabled>
              显示
            </Button>
          ) : (
            <Button type="primary" className="mr-20" onClick={this.getSaleList}>
              显示
            </Button>
          )}

          <Button
            className="mr-20"
            href={
              this.state.leadoutDatafff
                ? leadoutSaleTable(this.state.leadoutDatafff || [])
                : null
            }
            download={
              this.state.leadoutDatafff
                ? this.state.chosenDate + '报表.csv'
                : null
            }
          >
            导出报表
          </Button>
        </div>

        <div style={{marginTop: '30px'}}>
          <span style={{marginRight: '50px'}}>
            本月{this.state.categoryName}销售额:
            {this.state.monthAmount.toFixed(2) + '元'}
          </span>
          <span style={{marginRight: '50px'}}>
            本月{this.state.categoryName}销售总数:
            {this.state.monthQuantity.toFixed(0)}
          </span>
          <span>
            本月{this.state.categoryName}利润:
            {this.state.monthProfit.toFixed(2) + '元'}
          </span>
        </div>

        <div>
          <Table
              style={{marginTop: '30px'}}
              bordered
              columns={
                this.state.dataType == 1 ? mainColumns : CommodityMainColumns
            }
            expandable={{
              expandedRowRender,
              defaultExpandedRowKeys:
                this.state.mainList && this.state.mainList.length == 1
                  ? this.state.mainList[0].id
                  : null,
              // onExpand: (expanded, record) => {
              //   this.openMultiTable(expanded, record)
              // },
            }}
            dataSource={
              this.state.dataType == 1
                ? this.state.mainList
                : this.state.commodityMainList
            }
            size="small"
            rowKey={(record, index) => index}
          />
        </div>

        <Modal
          visible={this.state.visible}
          title="详情"
          onOk={this.onOk}
          onCancel={this.onCancel}
        >
          <Row className="mb-20">
            <Col span={8}>销售流水号：</Col>
            <Col span={16}>{this.state.detailData.sale.serialNumber}</Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>商品名称：</Col>
            <Col span={16}>{this.state.detailData.listing.name}</Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>数量：</Col>
            <Col span={16}>{this.state.detailData.sale.quantity}</Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>销售价格：</Col>
            <Col span={16}>
              {(this.state.detailData.sale.amount / 100).toFixed(2) + ' 元'}
            </Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>总成本：</Col>
            <Col span={16}>
              {(this.state.detailData.sale.costTotal / 100).toFixed(2) + ' 元'}
            </Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>钻石抵购：</Col>
            <Col span={16}>
              {this.state.detailData.saleDeduction
                ? (this.state.detailData.saleDeduction.amount / 100).toFixed(
                    2
                  ) +
                  ' 元 + ' +
                  this.state.detailData.saleDeduction.deduction +
                  '钻石'
                : '无'}
            </Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>客人名称：</Col>
            <Col span={16}>{this.state.detailData.member.memberName}</Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>客人账号：</Col>
            <Col span={16}>{this.state.detailData.member.account}</Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>球台名：</Col>
            <Col span={16}>{this.state.detailData.table.name}</Col>
          </Row>

          <Row className="mb-20">
            <Col span={8}>时间：</Col>
            <Col span={16}>
              {moment(this.state.detailData.sale.updateTime).format(
                'YYYY-MM-DD HH:mm'
              )}
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/saleRecord.js